// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3log-","fullView":"styles_fullView__1x8tQ"};